import t from '../actions/actionTypes'

const defaultState = {}

function addItemToLessons(item, lessons) {
	const entityUID = item.data.entityUID
	if (lessons[entityUID]) {
		const newEntity = {...lessons[entityUID]}
		const newEntityData = {...newEntity.data, ...item.data}
		if (newEntity.data.actions && item.data.actions) {
			const newEntityDataActions = {...newEntity.data.actions, ...item.data.actions}
			newEntityData.actions = newEntityDataActions
		}
		newEntity.data = newEntityData
		lessons[entityUID] = newEntity
	} else {
		lessons[entityUID] = item
	}
}

function changeLessonsFolderId(state, action) {
	const lesson = state[action.entityUID]
	if (!lesson) {
		return state
	} else {
		const newState = {...state}
		const newLesson = {...lesson}
		newLesson.data.folderId = '0'
		newState[lesson.data.entityUID] = newLesson
		return newState
	}
}

function productBuySuccesStateUpdate(state, action) {
	const newState = {...state}
	const presentation = action.payload.presentation
	newState[action.entityUID] = {...state[action.entityUID]}
	newState[action.entityUID].data = {...state[action.entityUID].data}
	newState[action.entityUID].data.state = 1
	if (presentation) {
		newState[action.entityUID].data.myLibraryEntityUID = presentation.data.entityUID
	}

	if (newState[action.entityUID].data.entities) {
		newState[action.entityUID].data.folderId = action.payload.folderId
		state[action.entityUID].data.entities.map(function(lessonIdFromBundle) {
			newState[lessonIdFromBundle] = {...state[lessonIdFromBundle]}
			newState[lessonIdFromBundle].data = {...state[lessonIdFromBundle].data}
			newState[lessonIdFromBundle].data.state = 1
		})
	}

	if (presentation) {
		if (presentation.data.entities) {
			presentation.data.entities.map(function(lessonFromBundle) {
				newState[lessonFromBundle.data.entityUID] = lessonFromBundle
			})
		} else {
			newState[action.entityUID].data.id = `FROM-STORE-${newState[action.entityUID].data.id}`
		}
		newState[presentation.data.entityUID] = presentation
	}
	return newState
}

function updateMyLibraryLessonsFetched(state, action) {
	const newState = {...state}
	const entities = action.lessonsData.result.entities
	const entitiesTips = action.lessonsData.result.entitiesTips || []
	entities.forEach(item => addItemToLessons(item, newState))
	entitiesTips.forEach(item => addItemToLessons(item, newState))

	return newState
}

//helper function
function updateLessonsNewState(entity, status) {
	entity = {...entity}
	entity.data = {...entity.data}
	entity.data.state = status
	return entity
}

function updateLessonState(state, action) {
	const newState = {...state}
	newState[action.entity.data.entityUID] = updateLessonsNewState(newState[action.entity.data.entityUID], 2)
	return newState
}

function resetLessonState(state, action) {
	const newState = {...state}
	newState[action.entity.data.entityUID] = updateLessonsNewState(newState[action.entity.data.entityUID], action.entity.data.state)
	return newState
}

function handleDeleteLessonSuccess(state, action) {
	const newState = {...state}
	newState[action.lesson.data.entityUID] = updateLessonsNewState(newState[action.lesson.data.entityUID], 100)
	return newState
}

function handleDeleteLessonFail(state, action) {
	const newState = {...state}
	newState[action.lesson.data.entityUID] = updateLessonsNewState(newState[action.lesson.data.entityUID], action.lesson.data.state)
	return newState
}

function handlePendingLessonsStatusFetched(state, action) {
	const newState = {...state}
	//loop through action.pending_lessons which is an array of lessons
	action.pending_lessons.forEach(function(object) {
		if (object.status === 1) {
			newState[object.id] = updateLessonsNewState(newState[object.id], 1)
		}
	})

	return newState
}

function handleSaveChangesFetched(state, action) {
	const newState = {...state}
	if (action.saveResponse.error_code === 1 || action.saveResponse.error_code === 2) {
		newState[action.saveResponse.id] = updateLessonsNewState(newState[action.saveResponse.id], 0)
	} else {
		newState[action.saveResponse.id] = updateLessonsNewState(newState[action.saveResponse.id], 2)
	}
	return newState
}

function handleRemoveLessonFromFolder(state, action) {
	const newState = {...state}
	newState[action.lesson.data.entityUID] = updateLessonsNewState(newState[action.lesson.data.entityUID], 101)
	return newState
}

function handleRemoveLessonFromFolderSuccess(state, action) {
	const newState = {...state}
	newState[action.lesson.data.entityUID] = updateLessonsNewState(newState[action.lesson.data.entityUID], action.lesson.data.state)
	return newState
}

function handleMoveLesson(state, action) {
	const newState = {...state}
	newState[action.lessonUID] = updateLessonsNewState(newState[action.lessonUID], 0)
	return newState
}

function handleLessonsPickerSearchFetched(state, action) {
	const entities = action.payload.entities
	if (!entities.length) {
		return state
	}
	const newState = {...state}
	entities.map(l => addItemToLessons(l, newState))
	return newState
}

function handlePreviewDataFetched(state, action) {
	const newState = {...state}
	let newEntity = {
		...action.response.result,
	}
	if (newEntity.data && newEntity.data.entities) {
		newEntity = {
			...newEntity,
			data: {
				...newEntity.data,
				entities: newEntity.data.entities.map(entity => {
					addItemToLessons(entity, newState)
					return entity.data.entityUID
				}),
			},
		}
	}
	addItemToLessons(newEntity, newState)
	action.response.promoted.forEach(promotedGroup => {
		promotedGroup.entities.forEach( entity => {
			addItemToLessons(entity, newState)
		})
	})
	return newState
}

function handleLessonDataFetched(state, action) {
	const newState = {...state}
	addItemToLessons(action.response.result, newState)
	return newState
}

function handleHomeworkDataFetched(state, action) {
	const newState = {...state}
	newState[action.presentationUid] = {
		...state[action.presentationUid],
		data: {
			...state[action.presentationUid].data,
			is_running: true,
		},
	}

	return newState
}

function updateGoogleSlidesLessonUnsaved(state, entityUID) {
	const newState = {...state}
	newState[entityUID] = updateLessonsNewState(newState[entityUID], 0)
	return newState
}

function setLesson(state, action) {
	const newState = {...state}
	addItemToLessons(action.entity, newState)
	return newState
}

function updateLessonsAuthorImage(state, action) {
	const newState = {...state}
	Object.keys(newState).map(
		entityUID => {
			if (newState[entityUID].data.author
				&& newState[entityUID].data.author.data.entityUID === action.userId) {
				newState[entityUID].data.author.data.thumb = action.icon.versions.default
			}
		}
	)
	return newState
}

function updateLessonsSaveProgress(state, action) {
	const entity = state[action.entityUID]
	let newState = state
	if (entity) {
		newState = {...state}
		const newEntity = {
			...entity,
			data: {
				...entity.data,
				progress: {
					...entity.data.progress,
					currentSlide: action.currentSlide,
					totalSlides: action.totalSlides,
				},
			},
		}
		newState[action.entityUID] = newEntity

	}
	return newState
}

const lessonsReducer = (state = defaultState, action) => {
	switch (action.type) {
		case t.LESSONS_SET_ALL:
		case t.STOREFRONT_FOUND_LESSONS:
		case t.BINDERS_LESSONS_FETCHED:
		case t.CART_ITEM_TOGGLED:
		case t.CART_DATA_FETCHED:
		case t.PRIVATE_LIBRARY_LESSONS_FETCHED:
		case t.PRIVATE_LIBRARY_SEARCH_FETCHED:
		case t.ONBOARDING_SUGGESTED_LESSONS_FETCHED:
		case t.STOREFRONT_OWNER_LESSONS_FETCHED:
		case t.STOREFRONT_VISITOR_LESSONS_FETCHED:
		case t.STORE_CONNECTOR_SEARCH_INITIALIZE:
		case t.STORE_CONNECTOR_SEARCH_UPDATE:
		case t.STORE_SEARCH_GET_RESULTS_SUCCESS:
		case t.STORE_FOLDER_GET_RESULTS_SUCCESS:
		{
			/*
			TODO: Buscar los entities que ya existen y no pisar los existentes.
			Ver si aplicar un timestamp del lado del server o como hacer.
			*/
			if (!action.entities.length) {
				return state
			}
			const newState = {...state}
			action.entities.map(l => addItemToLessons(l, newState))
			return newState
		}
		case t.PRIVATE_LIBRARY_FOLDER_REMOVE_LESSON_SUCCESS:
			return changeLessonsFolderId(state, action)
		case t.CART_BUY_PRODUCT_SUCCESS:
			return productBuySuccesStateUpdate(state, action)
		case t.MY_LIBRARY_LESSONS_FETCHED:
			return updateMyLibraryLessonsFetched(state, action)
		case t.MY_LIBRARY_SAVE_CHANGES:
		case t.MY_LIBRARY_LESSON_DATA_SAVED:
			return updateLessonState(state, action)
		case t.MY_LIBRARY_SAVE_CHANGES_FAILED:
		case t.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_START_FAILED:
			return resetLessonState(state, action)
		case t.MY_LIBRARY_PENDING_LESSONS_STATUS_FETCHED:
			return handlePendingLessonsStatusFetched(state, action)
		case t.MY_LIBRARY_SAVE_CHANGES_FETCHED:
			return handleSaveChangesFetched(state, action)
		case t.MY_LIBRARY_DELETE_LESSON_CONFIRMED:
			return handleDeleteLessonSuccess(state, action)
		case t.MY_LIBRARY_DELETE_LESSON_FAILED:
			return handleDeleteLessonFail(state, action)
		case t.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_CONFIRMED:
			return handleRemoveLessonFromFolder(state, action)
		case t.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_SUCCESS:
		case t.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_FAILED:
			return handleRemoveLessonFromFolderSuccess(state, action)
		case t.MY_LIBRARY_LESSONS_PICKER_SEARCH_LESSONS_FETCHED:
			return handleLessonsPickerSearchFetched(state, action)
		case t.MY_LIBRARY_PREVIEW_DATA_FETCHED:
		case t.STORE_PREVIEW_FETCHED:
		case t.PRIVATE_LIBRARY_PREVIEW_FETCHED:
			return handlePreviewDataFetched(state, action)
		case t.GOOGLE_SLIDES_INITIALIZE_SUCCESS:
			return handleLessonDataFetched(state, action)
		case t.MY_LIBRARY_MOVE_LESSON:
			return handleMoveLesson(state, action)
		case t.MY_LIBRARY_HOMEWORK_FETCHED:
			return handleHomeworkDataFetched(state, action)
		case t.GOOGLE_SLIDES_EDIT_LESSON_SUCCESS:
			return updateGoogleSlidesLessonUnsaved(state, action.lessonData.entityUID)
		case t.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_FAILED:
			return updateGoogleSlidesLessonUnsaved(state, action.entityUID)
		case t.INTERACTIVE_VIDEO_LESSON_FETCHED:
			return setLesson(state, action)
		case t.MY_ACCOUNT_SAVE_ICON_SUCCESS:
			return updateLessonsAuthorImage(state, action)
		case t.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_UPDATE:
			return updateLessonsSaveProgress(state, action)
		default:
			return state
	}
}

export default lessonsReducer
